import React from 'react';
import Link from 'gatsby-link';
import styled, { css } from 'styled-components';
import { theme, media } from 'styles';

const styles = css`
  display: flex;
  align-items: center;
  margin-left: 25px;
  border-left: 1px solid ${theme.colors.border};
  cursor: pointer;
  padding-left: 24px;
  height: 40px;
  color: ${theme.colors.navy};
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;

  &:first-child {
    margin-left: 0;
    border-left: 0;
    padding-left: 0;
  }

  ${props => props.tabletPlus && `display: none;`};
  ${media.tablet`display: flex`};

  img,
  svg {
    flex-shrink: 0;
    margin-right: 8px;
    width: 24px;
  }
`;

export default styled(({ tabletPlus, ...props }) => {
  if (props.external) {
    const { className, href } = props;
    return (
      <a className={className} href={href}>
        {props.children}
      </a>
    );
  }
  return <Link {...props} />;
})`
  ${styles};
`;



// WEBPACK FOOTER //
// ./src/components/shared/IconLink/IconLink.jsx